// apps/web/src/lib/firebase.ts
// Lazy init solo en cliente: no ejecutar initializeApp/getAuth en top-level para que next build no falle en SSR.

import { initializeApp, getApps, getApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";
import { getFirestore, type Firestore } from "firebase/firestore";
import { getStorage, type FirebaseStorage } from "firebase/storage";

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let db: Firestore | null = null;
let storage: FirebaseStorage | null = null;

function isBrowser() {
  return typeof window !== "undefined";
}

function getConfig() {
  return {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY!,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN!,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID!,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET!,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID!,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID!,
  };
}

export function getFirebaseApp(): FirebaseApp | null {
  if (!isBrowser()) return null;
  if (app) return app;
  app = getApps().length ? getApp() : initializeApp(getConfig());
  return app;
}

export function getFirebaseAuth(): Auth | null {
  if (!isBrowser()) return null;
  if (auth) return auth;
  const a = getFirebaseApp();
  if (!a) return null;
  auth = getAuth(a);
  return auth;
}

export function getFirebaseDb(): Firestore | null {
  if (!isBrowser()) return null;
  if (db) return db;
  const a = getFirebaseApp();
  if (!a) return null;
  db = getFirestore(a);
  return db;
}

export function getFirebaseStorage(): FirebaseStorage | null {
  if (!isBrowser()) return null;
  if (storage) return storage;
  const a = getFirebaseApp();
  if (!a) return null;
  storage = getStorage(a);
  return storage;
}
